// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'IvyOra', 'IvyOra Fallback', Georgia, Times New Roman, serif","fontStyle":"normal"},"className":"__className_338346","variable":"__variable_338346"};